<template>
  <section
    class="tutorial"
    :class="isMobile() ? 'mobile-overlay' : ''"
  >
    <!-- overlay -->
    <!-- Textbox a whatnot -->
    <!-- v-if podla use case -->
    <tutorial-tasks
      v-if="tutorialState.showObjectives"
      :tasks="tasks"
    />
    <tutorial-overlay
      v-if="
        tutorialState.anne.showAnne || tutorialState.tutorialMessage.showMessage
      "
      @click.prevent=""
      @mousedown.prevent=""
      @mouseup.prevent=""
      @touchstart.prevent=""
      @touchend.prevent=""
    />
    <tutorial-hand-settings
      v-if="tutorialState.mobile.show"
      style="pointer-events: auto"
      img-url="https://appspowerplaymanager.vshcdn.net/images/winter-sports/minigame/downhill/ui/tutorial/MOBIL_DH.png"
      @mousedown.stop=""
      @mouseup.stop=""
      @touchstart.stop=""
      @touchend.stop=""
      @click-continue="continueTask"
    >
      <!-- eslint-enable -->
      <div class="mobiler">
        <div class="buttons">
          <div
            class="button-group"
            :class="{ reverse: !gameSettingsState.isLeft }"
          >
            <img
              width="150"
              height="150"
              :src="`${pathAssets}/ui/tutorial/button_dh.png`"
              alt="button2"
            >
          </div>
        </div>
      </div>
    </tutorial-hand-settings>
    <tutorial-anne
      v-if="tutorialState.anne.showAnne"
      :is-right="isAnneRight()"
    />
    <tutorial-message-box
      v-if="tutorialState.tutorialMessage.showMessage"
      :key="tutorialCoreState.typeWriter"
      :type-write="tutorialCoreState.typeWriter"
      :class="{ offsetBot: tutorialState.tutorialMessage.offset }"
      :header-text="$t('anne')"
      :text="$t(tutorialState.tutorialMessage.message)"
      :color="tutorialState.tutorialMessage.color"
      :button-yellow-text="yellowText"
      @show-full-text="setTypewriteToInactive"
    />
    <tutorial-button-start v-if="tutorialState.showButtonStart && isMobile()" />
    <tutorial-buttons-movement
      v-if="tutorialState.showButtonsMovement && isMobile()"
    />
    <div
      v-if="!isMobile() && tutorialState.showBarStart"
      class="nomobile-start-bar"
    >
      <start-efficiency-bar
        :forced-size="100"
        glow
      />
    </div>
    <tutorial-info-keys v-if="!isMobile()" />
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import {
  WindowAspect,
  TutorialAnne,
  TutorialMessageBox,
  TutorialTasks,
  TutorialOverlay,
  TutorialHandSettings,
  gameSettingsState,
  tutorialCoreState,
} from '@powerplay/core-minigames-ui'
import {
  settings,
  tutorialManager
} from '@powerplay/core-minigames'
import type { TutorialObjective } from '@powerplay/core-minigames'
import { TutorialObjectiveIds } from '@/app/types'
import TutorialButtonStart from '@/components/Tutorial/TutorialButtonStart.vue'
import TutorialButtonsMovement from '@/components/Tutorial/TutorialButtonsMovement.vue'
import TutorialInfoKeys from '@/components/Tutorial/TutorialInfoKeys.vue'
import StartEfficiencyBar from '@/components/Inputs/StartEfficiencyBar.vue'
import { pathAssets } from '@/globals/globalvariables'
import {
  gatesState,
  tutorialState
} from '@/stores'

export default defineComponent({
  name: 'TutorialLogicComponent',
  components: {
    TutorialAnne,
    TutorialMessageBox,
    TutorialTasks,
    TutorialOverlay,
    TutorialButtonStart,
    TutorialButtonsMovement,
    TutorialInfoKeys,
    StartEfficiencyBar,
    TutorialHandSettings
  },
  mixins: [WindowAspect],
  data() {

    return {
      tasks: [],
      pathAssets,
      tutorialState: tutorialState(),
      gatesState: gatesState(),
      gameSettingsState: gameSettingsState(),
      tutorialCoreState: tutorialCoreState(),
    }

  },
  computed: {
    yellowText() {

      if (this.isMobile()) return this.$t('tapToContinue')
      return this.$t('clickToContinueTemp')

    }
  },
  watch: {
    tutorialState: {
      immediate: true,
      deep: true,
      handler() {

        this.updateTasks()

      },
    },
    gatesState: {
      handler() {

        this.updateTasks()

      },
      deep: true
    }

  },
  methods: {
    setTypewriteToInactive() {

      tutorialCoreState().typeWriter = false
      tutorialManager.setTypeWriting(false)

    },
    tutorialAction() {

      console.log('click')
      // tutorialEventManager.emitNextEvent()

    },
    updateTasks() {

      console.log('update tasks...')
      this.tasks = tutorialState().objectives.map((objective: TutorialObjective) => {

        let color = 'blue'
        if (objective.passed) color = 'green'
        if (objective.failed) color = 'red'
        return {
          color,
          text: `${this.$t(objective.name)} ${
            objective.name === (TutorialObjectiveIds.gates as string) ?
              `${gatesState().successCounter}/10` :
              ''
          }`,
        }

      })

    },
    isAnneRight(): boolean {

      if (gameSettingsState().isLeft) {

        return !tutorialState().anne.isRight

      }
      return tutorialState().anne.isRight

    },
    continueTask() {

      this.setThings()
      settings.saveValues()
      window.dispatchEvent(new Event('mousedown'))

    },
    setThings(): void {

      settings.update('quality', gameSettingsState().graphicsSettings)
      settings.update('sounds', gameSettingsState().volume ? 1 : 0)
      settings.update('qualityAuto', gameSettingsState().graphicsAuto ? 1 : 0)
      settings.update('isLeft', gameSettingsState().isLeft ? 1 : 0)

    }
  },
})
</script>

<style lang="less">
.tutorial {

    &.mobile-overlay {
        .tutorial-anne, .tutorial-mobil, .tutorial-hand-bottom {
            position: fixed;
        }
    }

  .tutorial-tasks {
    position: absolute;
    left: 1%;
    top: 17%;
  }
  .tutorial-anne {
    bottom: 0;
  }
  .offsetBot {
    bottom: 40%;
  }

  .nomobile-start-bar {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 375px;
    height: 375px;
  }
}

.mobiler {
    height: 100%;

    .buttons {
        position: relative;
        width: 100%;
        height: 100%;

        .button-group {
            position: absolute;
            bottom: 130px;
            left: 130px;
            right: 130px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            &.reverse {
                flex-direction: row-reverse;
            }
        }
    }
}
</style>
